export default [
    {
        path: '/DailycheckHomePage',
        name: 'DailycheckHomePage',
        component: () => import('../../views/Dailycheck/DailycheckHomePage.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/DailycheckPublishHome',
        name: 'DailycheckPublishHome',
        component: () => import('../../views/Dailycheck/DailycheckPublishHome.vue'),
        meta: {
            keepAlive: true
        }

    },
    {
        path: '/DailycheckPublishingNode', // 维保发布
        name: 'DailycheckPublishingNode',
        component: () => import('../../views/Dailycheck/CirculationNodes/DailycheckPublishingNode.vue'),

    },
    {
        path: '/DailycheckAuditNode', // 维保审核
        name: 'DailycheckAuditNode',
        component: () => import('../../views/Dailycheck/CirculationNodes/DailycheckAuditNode.vue'),

    },
    {
        path: '/DailycheckIssuingNode', //维保签发
        name: 'DailycheckIssuingNode',
        component: () => import('../../views/Dailycheck/CirculationNodes/DailycheckIssuingNode.vue'),

    },
    {
        path: '/draftDailycheckHome',
        name: 'draftDailycheckHome',
        component: () => import('../../views/Dailycheck/Dailycheckdraft/draftDailycheckHome.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/DailycheckreadonlyHome',
        name: 'DailycheckreadonlyHome',
        component: () => import('../../views/Dailycheck/Dailycheckreadonly/DailycheckreadonlyHome.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/DailycheckHistoryPage',
        name: 'DailycheckHistoryPage',
        component: () => import('../../views/Dailycheck/historyPage/DailycheckHistoryPage.vue'),
    },
    { //文件下载
        path: '/DailycheckFileDownload',
        name: 'DailycheckFileDownload',
        component: () => import('../../views/Dailycheck/Documents/DailycheckFileDownload.vue'),
    },
    { //文件生成
        path: '/DailycheckGenerateDocument',
        name: 'DailycheckGenerateDocument',
        component: () => import('../../views/Dailycheck/Documents/DailycheckGenerateDocument.vue'),
    }

]